import { IFourVariantXP } from '@faire/web-api--source/indigofair/settings/IFourVariantXP';
import { SettingConst } from '@faire/web-api--source/types';

/**
 * Iteration on LOGGED_OUT_PROMINENT_PRICE_PRODUCT_TILES_250317, changing prominence of different product tile elements.
 * https://www.notion.so/faire/Low-lift-testing-Batch-10-1e32efb5c25a80348984c5a516e2afb5
 */
export const BATCH_10_LOGGED_OUT_PRODUCT_TILES_250603 =
  'BATCH_10_LOGGED_OUT_PRODUCT_TILES_250603' as SettingConst<
    'BATCH_10_LOGGED_OUT_PRODUCT_TILES_250603',
    keyof typeof IFourVariantXP.Bucket,
    'RETAILER' | 'VISITOR_WEB' | 'VISITOR_PERF_APP_WEB'
  >;
